export default {
  releaseVersionDoc: 'https://docs.bugly.woa.com/openapi/',
};
